import { v4 as uuidv4 } from 'uuid';

export function generateShortUuid(length: number = 8): string {
  return uuidv4().replace(/-/g, '').slice(0, length);
}
